import React, { useContext } from 'react';
import { Box, Column, Row } from '@honda-canada/design-system-react';

import ActionLink from './ActionLink';
import CoverImage from './CoverImage';
import HeaderContext from '../service/HeaderContext';
import MenuHeader from './MenuHeader';
import { getGtmTitleValue } from '../../../utils/gtmEvents';

const MenuTypeList = ({ ctaLink, parentDisplayName, items, image }) => {
  const { gtmTags, setActiveMenu } = useContext(HeaderContext);

  return (
    <>
      <MenuHeader ctaLink={ctaLink} parentDisplayName={parentDisplayName} />
      <Row>
        <Column m={0}>
          <CoverImage image={image} />
        </Column>
        <Column m={0}>
          {items?.[0].items?.map(
            ({
              itemId,
              label,
              url: { href, linktype } = {},
              itemDisplayName,
              gtmInteractionType,
              gtmBodyStyle,
              gtmTitle,
            }) => (
              <Box key={itemId} mt={0} mb="m">
                <ActionLink
                  title={label}
                  href={href}
                  linktype={linktype}
                  parentDisplayName={parentDisplayName}
                  fontFamily="default"
                  gtmTags={gtmTags}
                  gtmTitle={getGtmTitleValue(gtmTitle, gtmBodyStyle, itemDisplayName)}
                  gtmInteractionType={gtmInteractionType}
                  onClick={() => setActiveMenu(null)}
                />
              </Box>
            ),
          )}
        </Column>
      </Row>
    </>
  );
};

export default MenuTypeList;
